import * as navbarGroupType from "./navbarGroupType";
import * as productType from "./productType";
import * as dateRangeType from "./dateRangeType";
import * as searchType from "./searchType";
import * as taxType from "./taxType";
import * as tradeType from "./tradeType";
import * as overPayType from "./overPayType";
import * as payType from "./payType";
import * as tradeStatusType from "./tradeStatusType";
import * as statusType from "./statusType";
import * as requisitionStatusType from "./requisitionStatusType";
import * as conditionType from "./conditionType";
import * as reportSourceType from "./reportSourceType";
import * as costType from "./costType";
import * as eatType from "./eatType";
import * as eatSearchType from "./eatSearchType";
import * as invoicePeriodType from "./invoicePeriodType";
import * as foodStatusType from "./foodStatusType";
import * as foodStockType from "./foodStockType";
import * as rankType from "./rankType";
import * as businessClassType from "./businessClassType";
import * as timeReportType from "./timeReportType";
import * as salePriceSeparateType from "./salePriceSeparateType";
import * as qtyType from "./qtyType";
import * as stockAdjustType from "./stockAdjustType";
import * as moduleTabType from "./moduleTabType";
import * as degreeType from "./degreeType";
import * as customerLevelType from "./customerLevelType";
import * as customerSaleType from "./customerSaleType";
import * as customerIdFillType from "./customerIdFillType";
import * as salePriceType from "./salePriceType";
import * as roundType from "./roundType";
import * as detailRoundType from "./detailRoundType";
import * as salePricePrintType from "./salePricePrintType";
import * as stockAvailableType from "./stockAvailableType";
import * as stockQueryScopeType from "./stockQueryScopeType";
import * as chartColorType from "./chartColorType";
import * as vehicleType from "./vehicleType";
import * as invoiceTargetType from "./invoiceTargetType";
import * as promotionType from "./promotionType";
import * as promotionConditionType from "./promotionConditionType";
import * as promotionDiscountType from "./promotionDiscountType";
import * as promotionTypeMap from "./promotionTypeMap";
import * as promotionModeType from "./promotionModeType";
import * as downloadIconType from "./downloadIconType";
import * as priceLabelType from "./priceLabelType";
import * as directoryType from "./directoryType";
import * as employeeType from "./employeeType";
import * as roleType from "./roleType";
import * as waitingType from "./waitingType";
import * as waitingIntervalType from "./waitingIntervalType";
import * as reserveDaysType from "./reserveDaysType";
import * as sourceType from "./sourceType";
import * as lineOAButtonType from "./lineOAButtonType";
import * as orderStatusType from "./orderStatusType";
import * as functionType from "./functionType";
import * as languageType from "./languageType";
import * as lineQRcodeBgColorType from "./lineQRcodeBgColorType";
import * as onlineOrderTableFontSizeType from "./onlineOrderTableFontSizeType";
import * as visionType from "./visionType";
import * as employeeStatusType from "./employeeStatusType";
import * as giftVoucherPromotionType from "./giftVoucherPromotionType";
import * as giftVoucherUsageConditionType from "./giftVoucherUsageConditionType";
import * as giftVoucherUseDateType from "./giftVoucherUseDateType";
import * as giftVoucherPeriodUnitType from "./giftVoucherPeriodUnitType";
import * as monthType from "./monthType";
import * as dayType from "./dayType";
import * as invoiceSheetType from "./invoiceSheetType";
import * as purchaseCostType from "./purchaseCostType";
import * as noPromotionComboType from "./noPromotionComboType";
import * as KDSStationType from "./KDSStationType";
import * as isShowAllType from "./isShowAllType";
import * as saleStatusType from "./saleStatusType";
import * as pickupType from "./pickupType";
import * as elecInvoiceSendEmailType from "./elecInvoiceSendEmailType";
import * as orderScopeType from "./orderScopeType";
import * as saleType from "./saleType";
import * as uploadLogType from "./uploadLogType";
import * as inventoryModeType from "./inventoryModeType";
import * as degreeConditionType from "./degreeConditionType";
import * as ignorePromotionType from "./ignorePromotionType";
import * as monthlyCostStatusType from "./monthlyCostStatusType";
import * as isERPPlatformUpload from "./isERPPlatformUpload";
import * as kioskTransactionType from "./kioskTransactionType";
import * as creditCardCommunicationType from "./creditCardCommunicationType";
import * as coinType from "./coinType";
import * as transferStatusType from "./transferStatusType";

export default {
  navbarGroupType,
  productType,
  dateRangeType,
  searchType,
  taxType,
  tradeType,
  overPayType,
  payType,
  tradeStatusType,
  statusType,
  requisitionStatusType,
  conditionType,
  reportSourceType,
  costType,
  eatType,
  eatSearchType,
  invoicePeriodType,
  foodStatusType,
  foodStockType,
  rankType,
  businessClassType,
  timeReportType,
  salePriceSeparateType,
  qtyType,
  stockAdjustType,
  moduleTabType,
  degreeType,
  customerLevelType,
  customerSaleType,
  customerIdFillType,
  salePriceType,
  roundType,
  detailRoundType,
  salePricePrintType,
  stockAvailableType,
  stockQueryScopeType,
  chartColorType,
  vehicleType,
  invoiceTargetType,
  promotionType,
  promotionConditionType,
  promotionDiscountType,
  promotionTypeMap,
  promotionModeType,
  downloadIconType,
  priceLabelType,
  directoryType,
  employeeType,
  roleType,
  waitingType,
  waitingIntervalType,
  reserveDaysType,
  sourceType,
  lineOAButtonType,
  orderStatusType,
  functionType,
  languageType,
  lineQRcodeBgColorType,
  onlineOrderTableFontSizeType,
  visionType,
  employeeStatusType,
  giftVoucherPromotionType,
  giftVoucherUsageConditionType,
  giftVoucherUseDateType,
  giftVoucherPeriodUnitType,
  monthType,
  dayType,
  invoiceSheetType,
  purchaseCostType,
  noPromotionComboType,
  KDSStationType,
  isShowAllType,
  saleStatusType,
  pickupType,
  elecInvoiceSendEmailType,
  orderScopeType,
  saleType,
  uploadLogType,
  inventoryModeType,
  degreeConditionType,
  ignorePromotionType,
  monthlyCostStatusType,
  isERPPlatformUpload,
  kioskTransactionType,
  creditCardCommunicationType,
  coinType,
  transferStatusType,
};
